import { useQuery } from "@tanstack/react-query";
import { fetchMasterPlan } from "../api/fetchMasterPlan";

export const useMasterPlan = (enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["masterPlan"],
    queryFn: () => fetchMasterPlan(),
    enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading,
    refetch,
  };
};

